import Axios from "axios";

import {
    API_URL, getApi,
    postApi
} from "@/service/api";
import router from "../../router";


const routes = {
    api_posicion: "/api/posicion/",
}


const state = {
    posiciones: [],
}

const mutations = {
    // Posiciones
    setPosiciones(state, payload) {
        state.posiciones = payload;
      },
}

const actions = {
    // Posiciones
    listPosiciones({ commit }) {
        if (!localStorage.getItem("token")) {
          router.push("/login");
        } else {
          commit("auth/LOGIN_REQUEST", null, { root: true });
          const response = getApi(API_URL + routes.api_posicion);
          response.then((res) => {
            commit("setPosiciones", res.data);
            commit("auth/LOGIN_SUCCESS", null, {root: true});
          })
          response.catch(() => {
            localStorage.removeItem("token");
            commit("LOGIN_ERROR", null, {root: true});
            router.push('/login');
          });
        }
      },
      putPosiciones({ commit }, data) {
        if (!localStorage.getItem("token")) {
          router.push("/login");
        } else {
          Axios.put(API_URL + routes.api_posicion + data.id + '/', data, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
            .catch(() => {
              localStorage.removeItem("token");
              commit("auth/LOGIN_ERROR", null, {root: true});
              router.push('/login');
            });
        }
      },
      postPosiciones({ commit }, data) {
        if (!localStorage.getItem("token")) {
          router.push("/login");
        } else {
          const url = API_URL + routes.api_posicion
          data = {
            'url': url,
            'data': data,
          }
  
          const response = postApi(data);
          response.catch(() => {
            localStorage.removeItem("token");
            commit("auth/LOGIN_ERROR", null, {root: true});
            router.push('/login');
          });
        }
      },
      deletePosiciones({ commit }, data) {
        if (!localStorage.getItem("token")) {
          router.push("/login");
        } else {
          Axios.delete(API_URL + routes.api_posicion + data.id + '/', {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
            .catch(() => {
              localStorage.removeItem("token");
              commit("auth/LOGIN_ERROR", null, {root: true});
              router.push('/login');
            });
        }
      },
}

const getters = {

}


// exportar propiedades
export const posiciones = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
